import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, stagger, VIEWPORT_LG } from "./motion";

export const ContactCTA = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative bg-[#0A0A0A] brand-texture py-28 md:py-40"
    >
      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={VIEWPORT_LG}
        className="max-w-5xl mx-auto px-6 md:px-12 text-center"
      >
        <motion.p
          variants={fadeUp}
          className="font-mono-accent text-[11px] md:text-sm tracking-[0.28em] uppercase text-[#737373] mb-8"
        >
          By Introduction Only
        </motion.p>
        <motion.h2
          variants={fadeUp}
          data-testid="contact-heading"
          className="font-heading text-4xl sm:text-5xl md:text-6xl font-medium tracking-tighter text-white leading-[1.02]"
        >
          Partner with Wolf Land.
        </motion.h2>
        <motion.p
          variants={fadeUp}
          className="mt-8 max-w-xl mx-auto text-base md:text-lg leading-relaxed text-[#A3A3A3]"
        >
          We work discreetly with a select group of institutional brokers. To explore an
          engagement, reach out to arrange a confidential introduction.
        </motion.p>
        <motion.div variants={fadeUp} className="mt-12">
          <a
            href="mailto:info@wlillc.com"
            data-testid="contact-cta-button"
            className="group inline-flex items-center gap-3 font-mono-accent text-[12px] tracking-[0.14em] uppercase px-10 py-5 bg-white text-black hover:text-[#00FFD1] transition-colors duration-300"
          >
            Request an Introduction
            <ArrowUpRight
              className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              strokeWidth={2}
            />
          </a>
        </motion.div>
      </motion.div>
    </section>
  );
};
